import MgtvApi from 'MgtvApi';
import ApiInvoker from 'apis/services/apiInvoker';
import Env from './env';
import { getCookie } from './index';


/* 获取M站登录 token */
export function getMphoneToken() {
  const hdcn = getCookie('HDCN');
  if (hdcn && typeof hdcn === 'string') {
    return hdcn.split('-')[0];
  }
  return null;
}

export function setUserInfo(data) {
  let ticket = data || null;
  if (ticket) {
    sessionStorage.setItem('LingxiUserInfo', (JSON.stringify(ticket)));
    return;
  }
  if (Env.isMgtvApp) {
    MgtvApi.getUserInfo((data) => {
      if (data) {
        ticket = data;
      } else {
        ticket = JSON.stringify({ ticket: null });
      }
      sessionStorage.setItem('LingxiUserInfo', ticket);
    });
    return;
  }
  ticket = { ticket: getMphoneToken() };
  sessionStorage.setItem('LingxiUserInfo', (JSON.stringify(ticket)));
}

function sleep(millisecond) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, millisecond);
  });
}

export async function setAsyncUserInfo() {
  if (Env.isMgtvApp) {
    await sleep(500);
  }
}


/* 判断登录 */
export function judgeLogin(callback) {
  if (Env.isLocal) {
    // 该代码方便本地调试
    callback();
  } else if (Env.isMgtvApp) { // app内登录
    MgtvApi.getUserInfo((data) => {
      let nowData = null;
      if (typeof data === 'string' && data) {
        nowData = JSON.parse(data);
      }
      if (!data || (nowData && !nowData.ticket)) {
        // 如果没登录
        // if (window.hasLogin) { // 防止多次调用sdk的调用
        //   return;
        // }
        // window.hasLogin = 1;
        MgtvApi.login((data) => {
          const { ticket } = JSON.parse(data);
          setUserInfo({ ticket });
          setTimeout(() => {
            if (!callback) {
              window.location.reload();
            } else {
              callback();
            }
          }, 300);
        });
      } else {
        const { ticket } = nowData;
        setUserInfo({ ticket });
        callback();
      }
    });
  } else { // M站登录
    const hdcn = getMphoneToken();
    const nowUrl = window.location.href;
    if (!hdcn) {
      window.location.href = `https://m.mgtv.com/login/?from=${encodeURIComponent(nowUrl)}`;
    } else if (callback) {
      callback();
    }
  }
}


export function judgeLoginV2(callback) {
  if (Env.isLocal) {
    // 该代码方便本地调试
    callback();
  } else if (Env.isMgtvApp) { // app内登录
    MgtvApi.getUserInfo((data) => {
      let nowData = null;
      if (typeof data === 'string' && data) {
        nowData = JSON.parse(data);
      }
      if (!data || (nowData && !nowData.ticket)) {
        // 如果没登录
        /* if (window.hasLogin) { // 防止多次调用sdk的调用
                            return;
                        }
                        window.hasLogin = 1; */
        MgtvApi.login((data) => {
          const { ticket } = JSON.parse(data);
          setUserInfo({ ticket });
          setTimeout(() => {
            if (!callback) {
              window.location.reload();
            } else {
              callback();
            }
          }, 300);
        });
      } else {
        callback();
      }
    });
  } else { // M站登录
    const hdcn = getMphoneToken();
    const nowUrl = window.location.href;
    if (!hdcn) {
      window.location.href = `https://m.mgtv.com/login/?from=${encodeURIComponent(nowUrl)}`;
    } else {
      callback();
    }
  }
}

/* 获取用户信息 */
export function getMgtvUserTicket() {
  /* return new Promise((resolve) => {
      if (Env.isLocal) {
        resolve({
          ticket: 'M2CX9255XSFXDUGZ25F0',
        });
      } else if (Env.isMgtvApp) {
        MgtvApi.getUserInfo((data) => {
          if (data) {
            resolve(JSON.parse(data));
          } else {
            resolve({ ticket: null });
          }
        });
      } else {
        resolve({ ticket: getMphoneToken() });
      }
    }); */
  if (Env.isLocal) {
    return { ticket: '51E8C2B213D33EA89C78F25F20A89801' }; // E7DX4384XVNOYCPZ1A33  BSLQDSOHD96IL6DPT3S0 本地测试token
  }
  if (!Env.isMgtvApp) {
    return { ticket: getMphoneToken() };
  }
  const val = sessionStorage.getItem('LingxiUserInfo');
  return (val && JSON.parse(val)) || { ticket: null };
}

export function getMgtvUserTicketV2(callback) {
  if (Env.isLocal) {
    callback({ ticket: 'BT3229OHD96HD6SBM1JG' }); // E7DX4384XVNOYCPZ1A33 本地测试token
    return;
  }
  if (!Env.isMgtvApp) {
    callback({ ticket: getMphoneToken() });
  } else {
    MgtvApi.getUserInfo((data) => {
      if (data) {
        if (typeof data === 'string') {
          callback(JSON.parse(data));
        } else {
          callback(data);
        }
      } else {
        callback({ ticket: null });
      }
    });
  }
}


/* M站登出 */
export function h5Logout() {
  return ApiInvoker.loadByImg('http://i.mgtv.com/account/logout');
}

/* 删除cookie */
export function delCookie(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = getCookie(name);
  if (cval != null) {
    document.cookie = `${name}=;path=/${process.env.VUE_APP_MPHONE_DOMAIN};domain=.mgtv.com;expires=${exp.toGMTString()}`;
    document.cookie = `${name}=;path=/;domain=.mgtv.com;expires=${exp.toGMTString()}`;
    document.cookie = `${name}=;path=/${process.env.VUE_APP_MPHONE_DOMAIN};domain=.lingxi.mgtv.com;expires=${exp.toGMTString()}`;
    document.cookie = `${name}=;path=/;domain=.lingxi.mgtv.com;expires=${exp.toGMTString()}`;
  }
}

